import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SortUtils = {
  
  customSort: (resourceData, property, sortAsc) => {
    let sortedData = [...resourceData];
    if (typeof sortedData.find(value => value[property] != undefined)[property] === 'string') {
      return sortedData.sort((a, b) => SortUtils.sortByString(a[property], b[property], sortAsc));
    } else {
      return sortedData.sort((a, b) => SortUtils.sortByNumber(a[property], b[property], sortAsc));
    }
  },
  
  sortByString: (a, b, sortAsc) => {
    const valueA = a?.toLowerCase() ?? '';
    const valueB = b?.toLowerCase() ?? '';
    return sortAsc ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  },
    
  sortByNumber: (a, b, sortAsc) => {
    const valueA = parseInt(a);
    const valueB = parseInt(b);
    return sortAsc ? valueA - valueB : valueB - valueA;
  },

  renderSortIcons: (sortDirection,sortColumn,column) =>{
    if (sortColumn === column) {
      return sortDirection === 'asc' ?
        <span className='d-flex flex-column sortingArrows height-15'>
          <FontAwesomeIcon icon={faCaretUp} size="sm"  />
          <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down opacity-25' />
        </span>
        : 
        <span className='d-flex flex-column sortingArrows height-15'>
          <FontAwesomeIcon icon={faCaretUp} size="sm" className='opacity-25' />
          <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down' />
        </span>;
    }
    return (
      <span className='d-flex flex-column sortingArrows height-15'>
        <FontAwesomeIcon icon={faCaretUp} size="sm" className='opacity-25' />
        <FontAwesomeIcon icon={faCaretDown} size="sm" className='align-caret-down opacity-25' />
      </span>
    );
  }
};